import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {ApiResponse} from '@models/api.response';
import {AccountLoginEventResponse} from '@models/account-login-event.response';
import {buildPath} from '@utils/util-builder';

@Injectable({
    providedIn: 'root'
})
export class LoginEventService {
    constructor(private readonly _httpClient: HttpClient) {
    }

    registerLoginEvent(): Observable<ApiResponse<AccountLoginEventResponse>> {
        return this._httpClient.post<ApiResponse<AccountLoginEventResponse>>(buildPath(['data-core/Account/login-event']), {});
    }
}
